import { render } from "./DatasetUploader.vue?vue&type=template&id=a47c2ca2"
import script from "./datasetUploader.js?vue&type=script&lang=js&external"
export * from "./datasetUploader.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__